import apiCore from '../../utils/api-core';

export function getZones() {
	return apiCore.get('/common/zone-names');
}

export function searchLocation(data) {
	return apiCore.post('/common/search-location', data);
}
